import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.error.to-string.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import { clearLocalStorage } from "@faire/help-center-self-serve/utils/localStorage";
import { getBrandEmail, getBrandToken } from "@faire/help-center-utils/serialized-data/getBrand";
import { getRetailerEmail, getRetailerToken } from "@faire/help-center-utils/serialized-data/getRetailer";
import { getUserEmail } from "@faire/help-center-utils/serialized-data/getUser";
import createTicket from "@faire/web-api/api/zendesk/create-ticket/post";
import { ICreateTicketRequest } from "@faire/web-api/com/faire/vendor/zendesk/ICreateTicketRequest";
import { trackCxFoundationsTicketcreated } from "@faire/web-api/events/cxFoundations/actionUnknown/ticketcreated";
import { trackCxFoundationsEmailUsPageSubmitButtonClick } from "@faire/web-api/events/cxFoundations/click/emailUsPageSubmitButton";
import { trackCxFoundationsEmailUsPageView } from "@faire/web-api/events/cxFoundations/view/emailUsPage";
import { trackHelpCenterAllTypesOfTicketCreationSubmit } from "@faire/web-api/events/helpCenter/submit/allTypesOfTicketCreation";
import { useStrictLocalization } from "@faire/web/common/localization";
import { markPageJsExecuted } from "@faire/web/common/performance/TrackPerformanceBreakdown/markPageJsExecuted";
import { useUserPerceivedLoadTimingWithKey } from "@faire/web/common/performance/userPerceivedLoadTiming/useUserPerceivedLoadTiming";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import { Formik } from "formik";
import React, { useState } from "react";
import { BackButton } from "../../components/BackButton";
import { TicketType } from "../../consts";
import { useEmailFormState } from "../../hooks/useEmailFormState";
import { useScrollToTopOnLoadEffect } from "../../hooks/useScrollToTopEffect";
import { useTrackPageViewEffect } from "../../hooks/useTrackPageViewEffect";
import { LimitedWidthWrapper } from "../components/LimitedWidthWrapper";
import { TicketForm } from "./TicketForm";
import { getOrderTokenFromField, getTicketPayload, uploadAttachmentIfAny, validateForm } from "./utils";
var PAGE_JS_EXECUTED_MARK = markPageJsExecuted();
export var EmailUsForm = function EmailUsForm() {
  useTrackPageViewEffect(trackCxFoundationsEmailUsPageView);
  useScrollToTopOnLoadEffect(10);
  var _useStrictLocalizatio = useStrictLocalization(),
    strictLocalize = _useStrictLocalizatio.strictLocalize;
  var _useState = useState(undefined),
    _useState2 = _slicedToArray(_useState, 2),
    attachment = _useState2[0],
    setAttachment = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isLoading = _useState4[0],
    setIsLoading = _useState4[1];
  var _useState5 = useState(""),
    _useState6 = _slicedToArray(_useState5, 2),
    errorMessage = _useState6[0],
    setErrorMessage = _useState6[1];
  var _useEmailFormState = useEmailFormState(),
    goToNextStep = _useEmailFormState.goToNextStep,
    selectedBrandOrder = _useEmailFormState.selectedBrandOrder,
    issueType = _useEmailFormState.issueType,
    retailerOrBrandToken = _useEmailFormState.retailerOrBrandToken,
    emailUsInitial = _useEmailFormState.emailUsInitial;
  var loadTimingRef = useUserPerceivedLoadTimingWithKey({
    name: "help_center-page_self_serve_email_us",
    enableTrackPerformanceBreakdown: "internal-tracking",
    pageLoadKey: "help_center-page_self_serve_email_us",
    isPageLoading: false,
    pageJsExecutedMark: PAGE_JS_EXECUTED_MARK
  });
  var afterSubmission = function afterSubmission() {
    setIsLoading(false);
    clearLocalStorage();
    goToNextStep({
      supportType: "email"
    });
  };
  var handleSubmit = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(values) {
      var _response$id, _ref2, _ref3, _getUserEmail, _response$id2, _getRetailerToken, _getBrandToken, _ref4, _ref5, _getUserEmail2, _response$id3, attachmentToken, orderToken, _getTicketPayload, ticketPayload, response;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            setIsLoading(true);
            _context.prev = 1;
            _context.next = 4;
            return uploadAttachmentIfAny(attachment);
          case 4:
            attachmentToken = _context.sent;
            orderToken = getOrderTokenFromField(selectedBrandOrder, values.orderNumber);
            _getTicketPayload = getTicketPayload({
              selectedBrandOrder: selectedBrandOrder,
              values: values,
              issueType: issueType,
              attachmentToken: attachmentToken
            }), ticketPayload = _getTicketPayload.ticketPayload;
            _context.next = 9;
            return createTicket(ICreateTicketRequest.build(ticketPayload));
          case 9:
            response = _context.sent;
            trackCxFoundationsTicketcreated(((_response$id = response === null || response === void 0 ? void 0 : response.id) !== null && _response$id !== void 0 ? _response$id : "").toString(), orderToken !== null && orderToken !== void 0 ? orderToken : "", retailerOrBrandToken);
            trackCxFoundationsEmailUsPageSubmitButtonClick(issueType, retailerOrBrandToken, (_ref2 = (_ref3 = (_getUserEmail = getUserEmail()) !== null && _getUserEmail !== void 0 ? _getUserEmail : getRetailerEmail()) !== null && _ref3 !== void 0 ? _ref3 : getBrandEmail()) !== null && _ref2 !== void 0 ? _ref2 : "", ((_response$id2 = response === null || response === void 0 ? void 0 : response.id) !== null && _response$id2 !== void 0 ? _response$id2 : "").toString(), orderToken, values.name, values.subject, values.description, values.email);
            trackHelpCenterAllTypesOfTicketCreationSubmit((_getRetailerToken = getRetailerToken()) !== null && _getRetailerToken !== void 0 ? _getRetailerToken : "", (_getBrandToken = getBrandToken()) !== null && _getBrandToken !== void 0 ? _getBrandToken : "", orderToken !== null && orderToken !== void 0 ? orderToken : "", (_ref4 = (_ref5 = (_getUserEmail2 = getUserEmail()) !== null && _getUserEmail2 !== void 0 ? _getUserEmail2 : getRetailerEmail()) !== null && _ref5 !== void 0 ? _ref5 : getBrandEmail()) !== null && _ref4 !== void 0 ? _ref4 : "", "", values.subject, values.description, issueType, TicketType.EMAIL, ((_response$id3 = response === null || response === void 0 ? void 0 : response.id) !== null && _response$id3 !== void 0 ? _response$id3 : "").toString(), values.email, "");
            afterSubmission();
            _context.next = 20;
            break;
          case 16:
            _context.prev = 16;
            _context.t0 = _context["catch"](1);
            setErrorMessage(strictLocalize({
              id: "6vUWuh",
              defaultMessage: [{
                "type": 0,
                "value": "O seu pedido falhou. Tente novamente."
              }]
            }));
            setIsLoading(false);
          case 20:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 16]]);
    }));
    return function handleSubmit(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/React.createElement(LimitedWidthWrapper, {
    ref: loadTimingRef
  }, /*#__PURE__*/React.createElement(BackButton, null), /*#__PURE__*/React.createElement(Spacer, {
    height: "4x"
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "sectionHeaderSansMedium"
  }, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "08c/f0",
    defaultMessage: [{
      "type": 0,
      "value": "Pedir ajuda"
    }]
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "wTyYp9",
    defaultMessage: [{
      "type": 0,
      "value": "Preencha este formulário e iremos enviar uma resposta para o endereço de e-mail indicado abaixo no prazo de 1 dia útil."
    }]
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "3x"
  }), /*#__PURE__*/React.createElement(Formik, {
    enableReinitialize: true,
    initialValues: emailUsInitial,
    validate: function validate(values) {
      return validateForm(values, strictLocalize);
    },
    onSubmit: handleSubmit
  }, /*#__PURE__*/React.createElement(TicketForm, {
    attachment: attachment,
    setAttachment: setAttachment,
    isLoading: isLoading,
    errorMessage: errorMessage,
    setErrorMessage: setErrorMessage
  })));
};